import { createContext, useCallback, useContext, useEffect, useState } from "react";
import merchantApi from "../lib/merchantApi";
import { useMerchantAuth } from "./MerchantAuthContext";

const Ctx = createContext({
  application: null,
  dashboard: null,
  loading: true,
  error: null,
  refresh: async () => {},
  refreshDashboard: async () => {},
});

export function MerchantApplicationProvider({ children }) {
  const { user } = useMerchantAuth();
  const [application, setApplication] = useState(null);
  const [dashboard, setDashboard] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await merchantApi.get("/merchant/application");
      setApplication(data);
      setError(null);
      return data;
    } catch (err) {
      setError(err);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const refreshDashboard = useCallback(async () => {
    try {
      const { data } = await merchantApi.get("/merchant/dashboard");
      setDashboard(data);
      setApplication(data.application);
      setError(null);
      return data;
    } catch (err) {
      setError(err);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch only when authenticated; reset when logged out so a re-login starts fresh.
  useEffect(() => {
    if (user) {
      setLoading(true);
      refresh();
    } else {
      setApplication(null);
      setDashboard(null);
      setLoading(false);
    }
  }, [user, refresh]);

  return (
    <Ctx.Provider value={{ application, dashboard, loading, error, refresh, refreshDashboard }}>
      {children}
    </Ctx.Provider>
  );
}

export function useMerchantApplication() { return useContext(Ctx); }
